export default __webpack_public_path__ + "static/media/notifications_3.d0a60a49.png";